import { actionType } from "../../helpers/reducers";

export const AUTOCOMPLETE_SET = "autocomplete/SET";
export const AUTOCOMPLETE_REMOVE = "autocomplete/REMOVE";
export const AUTOCOMPLETE_PAGE_REMOVE = "autocomplete/PAGE_REMOVE";

export const setAutoComplete = actionType(AUTOCOMPLETE_SET);
export const removeAutoComplete = actionType(AUTOCOMPLETE_REMOVE);
export const removePageAutoComplete = actionType(AUTOCOMPLETE_PAGE_REMOVE);
